import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/Home.vue';
import AppLayout from './AppLayout.vue';
import RouterView from './components/layout/RouterView.vue';
import Login from './views/auth/Login.vue';
import Checkout from './views/auth/Checkout.vue';
import Employees from './views/employees/List.vue';
import Details from './views/employees/Details.vue';
import Calendar from './views/calendar/Calendar.vue';
import Settings from './views/user/Settings.vue';
import Company from './views/company/Company.vue';
import Holidays from './views/holidays/Edit.vue';
import Equipment from './views/equipment/list.vue';
import Timetable from './views/timetable/List.vue';
import Timesheet from './views/timesheet/Timesheet.vue';
import EquipmentTypes from './views/equipment/EquipmentTypes.vue';
import GroupWorkdays from './views/group/Workdays.vue';
import LogicalStructure from './views/logicalStructure/List.vue';
import Absence from './views/absence/Absence.vue';
import Panels from './views/panels/Panels.vue';
import HolidaySummary from './views/holidaySummary/HolidaySummary.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/auth',
      name: 'login',
      component: Login
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/timesheet/:id',
      name: 'timesheet',
      component: Timesheet
    },
    {
      path: '/',
      component: AppLayout,
      children: [
        {
          path: '',
          redirect: { name: 'home' }
        },
        {
          path: 'home',
          name: 'home',
          component: Home
        },
        {
          path: 'employees',
          redirect: { name: 'employees' }
        },
        {
          path: 'employees/index',
          name: 'employees',
          component: Employees
        },
        {
          path: 'employee/:id',
          name: 'employee',
          component: Details
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings
        },
        {
          path: 'holidays',
          name: 'holidays',
          component: Holidays
        },
        {
          path: 'companies',
          name: 'companies',
          component: Company
        },
        {
          path: 'equipment',
          name: 'equipment',
          component: Equipment
        },
        {
          path: 'timetable',
          name: 'timetable',
          component: Timetable
        },
        {
          path: 'equipmenttypes',
          name: 'eqtypes',
          component: EquipmentTypes
        },
        {
          path: 'group',
          name: 'group',
          component: RouterView,
          children: [{ path: 'workdays', component: GroupWorkdays }]
        },
        {
          path: 'logicalStructure',
          name: 'logicalStructure',
          component: LogicalStructure,
          children: [
            {
              path: '*',
              component: LogicalStructure
            }
          ]
        },
        {
          path: 'absence',
          name: 'absence',
          component: Absence
        },
        {
          path: 'panels',
          name: 'panels',
          component: Panels
        },
        { path: 'holiday-summary', name: 'holiday-summary', component: HolidaySummary }
      ]
    }
  ]
});
